import * as React from 'react';
import { Component } from 'react';
import { ListRendererProps } from 'app/area/codetable/list/list-renderer/types';
import { DefaultCodetableListComponent } from 'app/area/codetable/list/list-items/default-codetable-list-component';

export class CodetableListRenderer extends Component<ListRendererProps> {
  public render() {
    const { screenToRender } = this.props;

    if (!screenToRender?.component) {
      return <DefaultCodetableListComponent {...this.props} />;
    }

    const ScreenComponent = screenToRender.component;

    return <ScreenComponent {...this.props} {...screenToRender.screenProps} screenPayload={screenToRender} />;
  }
}
